import { Link } from 'react-router-dom';
import { styled } from '@goodrx/matisse';

export const LegalLink = styled(Link)`
  color: ${(p: any) => p.theme.colors.primary};
  font-weight: 500;
`;
